<script setup lang="ts">
import { computed } from 'vue'
import type { FairRadioButtonPreviewState } from '@/ui/tokens/radio.data'

interface FairRadioButtonIndicatorProps {
  selected?: boolean
  disabled?: boolean
  previewState?: FairRadioButtonPreviewState
}

const props = withDefaults(defineProps<FairRadioButtonIndicatorProps>(), {
  selected: false,
  disabled: false,
  previewState: undefined,
})

const indicatorClass = computed(() => ({
  'fair-radio-button-indicator': true,
  'fair-radio-button-indicator--selected': props.selected,
  'fair-radio-button-indicator--disabled':
    props.disabled || props.previewState === 'disabled',
  [`fair-radio-button-indicator--preview-${props.previewState}`]:
    Boolean(props.previewState),
}))
</script>

<template>
  <span
    :class="indicatorClass"
    aria-hidden="true"
  >
    <span class="fair-radio-button-indicator__dot" />
  </span>
</template>
